import React, { useEffect, useRef, useState } from "react";
import { Star, ChevronDown } from "lucide-react";

const PRESETS = [["Hepsi", []], ["1-3 ★", [1, 2, 3]], ["4-5 ★", [4, 5]], ["5 ★", [5]]];

export default function StarFilter({ value, onChange }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const sel = (value || "").split(",").filter(Boolean).map(Number);
  useEffect(() => {
    const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h); return () => document.removeEventListener("mousedown", h);
  }, []);
  const set = (arr) => onChange([...new Set(arr)].sort((a, b) => b - a).join(","));
  const toggle = (n) => set(sel.includes(n) ? sel.filter(x => x !== n) : [...sel, n]);
  const label = sel.length === 0 ? "Tüm yıldızlar" : sel.length === 5 ? "Tüm yıldızlar" : `${[...sel].sort().join(", ")} ★`;
  return (
    <div className="relative" ref={ref} data-testid="filter-ratings">
      <button type="button" onClick={() => setOpen(o => !o)} className={`bg-slate-800 border ${sel.length ? "border-amber-500/60 text-amber-300" : "border-slate-700 text-white"} text-sm rounded-lg px-3 py-1.5 flex items-center gap-2`} data-testid="filter-ratings-btn">
        <Star className="w-3.5 h-3.5" /> {label} <ChevronDown className="w-3.5 h-3.5 text-slate-500" />
      </button>
      {open && (
        <div className="absolute z-30 mt-1 w-56 bg-slate-900 border border-slate-700 rounded-xl shadow-2xl p-2" data-testid="filter-ratings-menu">
          <div className="flex flex-wrap gap-1 mb-2">
            {PRESETS.map(([l, arr]) => (
              <button key={l} type="button" onClick={() => set(arr)} className="text-[11px] px-2 py-0.5 rounded bg-slate-800 hover:bg-slate-700 text-slate-300" data-testid={`ratings-preset-${l}`}>{l}</button>
            ))}
          </div>
          {[5, 4, 3, 2, 1].map(n => (
            <label key={n} className="flex items-center gap-2 px-2 py-1.5 rounded-lg hover:bg-slate-800 cursor-pointer text-sm text-slate-200">
              <input type="checkbox" checked={sel.includes(n)} onChange={() => toggle(n)} className="accent-amber-500" data-testid={`ratings-check-${n}`} />
              <span className="text-amber-400 inline-flex">{Array.from({ length: n }).map((_, i) => <Star key={i} className="w-3 h-3" fill="currentColor" strokeWidth={0} />)}</span>
              <span className="text-slate-400 text-xs ml-auto">{n} yıldız</span>
            </label>
          ))}
        </div>
      )}
    </div>
  );
}
